import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { PureComponent } from 'react';
import Collapse from 'react-css-collapse';
import Validation from '../Validation';
class CollapseValidation extends PureComponent {
    render() {
        const { validationText, hideValidationText, validationClassName, additionalClassName } = this.props;
        return /*#__PURE__*/ React.createElement(Collapse, {
            isOpen: validationText !== null && !hideValidationText,
            className: cx([
                'ReactCollapse',
                additionalClassName
            ])
        }, validationText ? /*#__PURE__*/ React.createElement(Validation, {
            className: validationClassName
        }, validationText) : /*#__PURE__*/ React.createElement("div", null));
    }
}
CollapseValidation.propTypes = {
    additionalClassName: PropTypes.string,
    hideValidationText: PropTypes.bool,
    validationClassName: PropTypes.string,
    validationText: PropTypes.string
};
export default CollapseValidation;
